import { render, staticRenderFns } from "./SoftwareMag.vue?vue&type=template&id=86a99bd4&scoped=true&"
import script from "./SoftwareMag.vue?vue&type=script&lang=js&"
export * from "./SoftwareMag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a99bd4",
  null
  
)

export default component.exports